import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
    state: {
        token: localStorage.getItem("token") || null,
        user: JSON.parse(localStorage.getItem("res.data")),
        profile_pic: null,
        new_publisher: null,
        country_code:localStorage.getItem("country_code") || null,
        tracker: localStorage.getItem("tracker") || 0,
    },
    mutations,
    actions,
    getters,
};
